import React from 'react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, xcss } from '@atlaskit/primitives';

import { LoadingSkeleton } from '../../../common/ui/loading-skeleton';
// eslint-disable-next-line @atlassian/tangerine/import/no-parent-imports
import { type SidebarProps } from '../types';

type ExpandedSectionProps = Pick<SidebarProps, 'hasError' | 'isExpanded' | 'isLoading'> & {
	children?: React.ReactNode;
};

const styles = xcss({
	width: '100%',
	marginTop: 'space.400',
	marginBottom: 'space.400',
	marginLeft: 'space.400',
});

const loadingStyles = xcss({
	borderRadius: 'radius.large',
	borderStyle: 'solid',
	borderWidth: 'border.width',
	borderColor: 'color.border',
	padding: 'space.300',
});

export const ExpandedSection = ({
	hasError,
	isExpanded,
	isLoading,
	children,
}: ExpandedSectionProps): React.JSX.Element | null => {
	// On error, it expands out the error section from the main section
	if (!isExpanded || hasError) {
		return null;
	}

	if (isLoading) {
		return (
			<Box testId="sidebar-expanded-loading" xcss={[styles, loadingStyles]}>
				<LoadingSkeleton />
			</Box>
		);
	}

	return (
		<Box testId="sidebar-expanded" xcss={styles}>
			{children}
		</Box>
	);
};
